var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#2B4896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 16H16V256H256V16Z",
    fill: "#2B4896"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.091 122.344L-6.2373 264.688H18.8877V272.641L139.403 137.422L122.091 122.344Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61646 283.43L125.704 145.236L116.241 146.164V145.727L-4.16479 278.18L1.61646 283.43Z",
    fill: "#E74C3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.39 -1.16113L127.062 141.183H152.187V149.136L273.203 14.917L255.39 -1.16113V-1.16113Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.625 0.735352L135.875 138.001H146V138.438L266.406 5.98535L260.625 0.735352V0.735352Z",
    fill: "#E74C3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.155 153.048L-6.83875 6.07038L18.2692 6.99656L18.5624 -0.951162L134.548 137.637L116.155 153.048V153.048Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.456 151.346L1.85076 9.57474L11.9689 9.94798L11.985 9.51077L127.427 146.312L121.456 151.346V151.346Z",
    fill: "#E74C3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156 16H116V256H156V16Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M155.25 127.043L283.578 269.387H258.453V277.34L137.438 143.121L155.25 127.043V127.043Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M150.016 128.939L274.766 266.205H264.641V266.643L144.234 134.189L150.016 128.939V128.939Z",
    fill: "#E74C3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M256 156V116H16V156H256Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148 16H124V256H148V16Z",
    fill: "#E74C3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M256 148V124H16V148H256Z",
    fill: "#E74C3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M390.078 340.481L394.549 354.381L408.203 349.21L400.123 361.371L412.679 368.822L398.134 370.087L400.137 384.549L390.078 373.966L380.02 384.549L382.023 370.087L367.478 368.822L380.034 361.371L371.954 349.21L385.608 354.381L390.078 340.481Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M308.942 212.016L313.412 225.915L327.066 220.744L318.987 232.905L331.543 240.356L316.997 241.621L319 256.084L308.942 245.5L298.884 256.084L300.887 241.621L286.342 240.356L298.897 232.905L290.818 220.744L304.472 225.915L308.942 212.016Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M390.078 124.117L394.549 138.016L408.203 132.845L400.123 145.006L412.679 152.457L398.134 153.723L400.137 168.185L390.078 157.602L380.02 168.185L382.023 153.723L367.478 152.457L380.034 145.006L371.954 132.845L385.608 138.016L390.078 124.117Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M462.2 190.379L466.67 204.278L480.324 199.107L472.244 211.268L484.8 218.719L470.255 219.985L472.258 234.447L462.2 223.864L452.142 234.447L454.144 219.985L439.599 218.719L452.155 211.268L444.075 199.107L457.729 204.278L462.2 190.379Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M422.533 255.481L426.066 264.142L435.394 264.825L428.249 270.861L430.481 279.944L422.533 275.014L414.585 279.944L416.817 270.861L409.672 264.825L419 264.142L422.533 255.481Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136 292.149L145.373 321.293L174.002 310.45L157.061 335.949L183.388 351.572L152.89 354.225L157.09 384.549L136 362.359L114.91 384.549L119.11 354.225L88.6118 351.572L114.939 335.949L97.9976 310.45L126.627 321.293L136 292.149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/AU.dfdc9a4be670c8fd463e965e478c4af6.svg";
export { ForwardRef as ReactComponent };